module.exports = __webpack_public_path__ + "static/erwin-019ac365c2b2ea68f0c2cec3318a9d88.png";